import React from 'react';
import { Marker } from 'react-google-maps';
import { InfoBox } from 'react-google-maps/lib/components/addons/InfoBox';
import { getTranslateLang } from "../services/Translates";
import { connect } from "react-redux";
import { activeChange } from "./../actions";

let getOptions = ( id, options ) => {
    let optionsTemp = [];
    if ( options.length > 0 ) {
        let items = options.filter( item => {
            return id.includes(item.id)
        })
        optionsTemp = [...optionsTemp, items];
    }
    return optionsTemp;
}

const Pin = (props) => {
    let iconMarker = { url: props.iconMap, scaledSize: { width: 42, height: 42 } };
    let data = props.data[0];
    let options = getOptions(data.options, props.options);
    
    return (
        <>
            <Marker
                position={{ lat: props.lat, lng: props.lng }}
                icon={iconMarker}
                onClick={ () => { props.activeChange(data.device_id); props.seeOnMap(data.device_latitude, data.device_longitude) } }
            >
            { props.active == data.device_id && 
                <InfoBox options={{ closeBoxURL: ``, enableEventPropagation: true }}>
                    <div className="modal">
                        <div className="close" onClick={ () => { props.activeChange(99999); props.changeActiveTemp(99999) } }>X</div>
                        <div className="content">
                            <p className="title"><b>{ data.device_name }</b></p>
                            {/* { data.device_address && 
                                 <span>{ data.device_address }</span>
                            }
                            { !data.device_address && 
                                 <span>Brak w bazie</span>
                            } */}
                            <div className="info">
                                <div className="info-item">
                                    <div className="icon">
                                        <img src={ props.iconType } alt=""/>
                                    </div>
                                    <p>{ getTranslateLang('typ_myjni') } 
                                        { data.group_name && 
                                            <b> { getTranslateLang(data.group_name) } </b>
                                        }
                                        { !data.group_name && 
                                            <b> Brak w bazie</b>
                                        }
                                    </p>
                                </div>
                                <div className="info-item">
                                    <div className="icon">
                                        <img src={ props.iconCount } alt=""/>
                                    </div>
                                    <p>{ getTranslateLang('liczba_stanowisk') } 
                                    { data.code_stands && 
                                        <b> { data.code_stands }</b>
                                    }
                                     { !data.code_stands && 
                                        <b> Brak w bazie</b>
                                    }
                                    </p>
                                </div>
                            </div>

                            <div className="icons">
                                { options && options.length > 0 && options[0].map( option => (
                                    <>
                                    <img src={ option.img } alt={ option.translate } title={ option.translate } />
                                    </>
                                ))}
                            </div>
                            { data.domain &&
                                <>
                                    { data.domain == props.domain && 

                                        <a href={ data.link } >{ getTranslateLang('zobacz_w_realizacjach') }</a>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </InfoBox>
            }
            </Marker>
        </>
    )
   
}

const mapStateToProps = state => {
    return {
        active: state.active,
    };
  };
  
  const mapDispatchToProps = { activeChange };
  
  export const PinContainer = connect(
    mapStateToProps,
    mapDispatchToProps
  )(Pin);
